export function moveFundamentalPrice(){
        const priceNotice = document.querySelector(".priceNotice");
        const fundamentalPrice = document.querySelector(".fundamentalPrice .priceNotice");

        if (priceNotice && fundamentalPrice) {
            const fundamentalText = fundamentalPrice.textContent.trim();

            priceNotice.innerHTML = `<span>${fundamentalText} · ${priceNotice.innerHTML}</span>`;

            fundamentalPrice.parentElement.style.display = "none";
        }
}